import { render, staticRenderFns } from "./ChatGroupLinkMessage.vue?vue&type=template&id=4618789c&scoped=true&lang=pug"
import script from "./ChatGroupLinkMessage.vue?vue&type=script&lang=js"
export * from "./ChatGroupLinkMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupLinkMessage.vue?vue&type=style&index=0&id=4618789c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618789c",
  null
  
)

export default component.exports